import { render } from "./SubclassEditView.vue?vue&type=template&id=653af642"
import script from "./SubclassEditView.vue?vue&type=script&lang=js"
export * from "./SubclassEditView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/git/index-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__